import React, { FunctionComponent } from 'react';
import { Image } from '@doveit/bricks';
import * as styles from './SoldPropertyCard.style';

export interface SoldPropertyCardProps {
  title: string,
  saving: string,
  image: string,
  banner?: string,
}

const SoldPropertyCard: FunctionComponent<SoldPropertyCardProps> = ({
  title,
  saving,
  image,
  banner,
}) => (
  <article css={styles.basic}>
    <div css={styles.title}>{title}</div>
    <div
      css={styles.saving}
      dangerouslySetInnerHTML={{ __html: saving }}
    />
    <div css={styles.imageWrapper}>
      {banner && (
        <div
          data-ref="banner"
          css={styles.banner}
        >
          {banner}
        </div>
      )}
      <div css={styles.image}>
        <Image
          src={image}
          alt={`Anteprima ${title}`}
          loading="lazy"
          responsive
        />
      </div>
    </div>
  </article>
);

export default SoldPropertyCard;
